var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.166667, 4.166667)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0833333,0.591666667 C10.7583333,0.266666667 10.2333333,0.266666667 9.90833333,0.591666667 L5.83333333,4.65833333 L1.75833333,0.583333333 C1.43333333,0.258333333 0.908333333,0.258333333 0.583333333,0.583333333 C0.258333333,0.908333333 0.258333333,1.43333333 0.583333333,1.75833333 L4.65833333,5.83333333 L0.583333333,9.90833333 C0.258333333,10.2333333 0.258333333,10.7583333 0.583333333,11.0833333 C0.908333333,11.4083333 1.43333333,11.4083333 1.75833333,11.0833333 L5.83333333,7.00833333 L9.90833333,11.0833333 C10.2333333,11.4083333 10.7583333,11.4083333 11.0833333,11.0833333 C11.4083333,10.7583333 11.4083333,10.2333333 11.0833333,9.90833333 L7.00833333,5.83333333 L11.0833333,1.75833333 C11.4,1.44166667 11.4,0.908333333 11.0833333,0.591666667 Z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.dd944b17.svg";
export { ForwardRef as ReactComponent };